import axios from '@pepper/utils/src/function/axiosInstance'
import extract from '@pepper/utils/src/function/extract'
import { USER_SERVICE_BASE_URL } from '@pepper/utils/src/api/config'

type CompaniesLeadsProps = {
  ['SFT Clicked on SFT Flow']?: string
  ['BAD Clicked on SFT Flow']?: string
  ['OTP Verified']?: string
  ['First Name']?: string
  ['Last Name']?: string
  ['Start a Free Trial Started']?: string
  Phone?: string
  Department?: string
  Goals?: string
  Company?: string
  Website?: string
  Country?: string
  Role?: string
  Source?: string
}

export const createSalesforceLead = async (reqPayload: CompaniesLeadsProps) => {
  try {
    const url = `${USER_SERVICE_BASE_URL}/companies-leads`
    const response = await axios.post(url, reqPayload)
    return extract.data(response)
  } catch (error) {
    return extract.error(error)
  }
}
